export const POLICY_TYPE = {
  NEW: 'NEW',
  RENEWAL: 'RENEWAL',
  ROLL_OVER: 'ROLL_OVER',
}

export const POLICY_HOLDER_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  CORPORATE: 'CORPORATE',
}

export const RENEWAL_DECISION = {
  VERIFICATION_COMPLETE: 'VERIFICATION_COMPLETE',
  VERIFICATION_PENDING: 'VERIFICATION_PENDING',
}

export const ACTION_TYPE = {
  SAVE: 'SAVE',
  SUBMIT: 'SUBMIT',
}

export const PRODUCT_TYPE = {
  GENERAL: 'GENERAL',
  LIFE: 'LIFE',
}

export const RENEWAL_MIGRATION = {
  MIGRATE_EMPLOYEES: 'migrateEmployees',
  DONOT_MIGRATE_EMPLOYEES: 'dontMigrateEmployees',
  MIGRATE_FAMILY_MEMBERS: 'migrateFamilyMembers',
  DONOT_MIGRATE_FAMILY_MEMBERS: 'dontMigrateFamilyMembers',
}

export const INTERMEDIARY_VALUE = {
  TROVITY: 'trovity',
  OTHERS: 'others',
}

export const PAYMENT_OPTIONS = {
  ONE_TIME: 'ONE_TIME_PAYMENT',
  INSTALLMENTS: 'INSTALLMENT',
}
